import React from 'react';

import { Badge, createStyles, Group, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import ActivePackagesContent from 'pages/private/owner/AthleteDetail/components/GeneralInfo/components/ActivePackagesContent';
import AthleteNotesContent from 'pages/private/owner/AthleteDetail/components/GeneralInfo/components/AthleteNotesContent';
import ConnectedProfilesCard from 'pages/private/owner/AthleteDetail/components/GeneralInfo/components/ConnectedProfilesCard';
import GeneralContent from 'pages/private/owner/AthleteDetail/components/GeneralInfo/components/GeneralContent';
import PaymentMethodsContent from 'pages/private/owner/AthleteDetail/components/GeneralInfo/components/PaymentMethodsContent';
import StatusHistoryCard from 'pages/private/owner/AthleteDetail/components/GeneralInfo/components/StatusHistoryCard';
import { AthleteRetrieve } from 'types';

const useStyles = createStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.lg,
  },
  tabText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: theme.spacing.xs,
  },
  badges: {
    marginTop: -12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface IGeneralInfoProps {
  athlete: AthleteRetrieve;
  openTabsDrawer: () => void;
  permission?: boolean;
}

const GeneralInfo = ({ athlete, openTabsDrawer, permission = true }: IGeneralInfoProps): JSX.Element => {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <Group>
        <Text size='md' fw='bold' className={classes.tabText} onClick={openTabsDrawer}>
          General Info
          <IconChevronDown size={16} style={{ marginLeft: 4 }} />
        </Text>
      </Group>
      {athlete.primaryAccount ||
        (!athlete.loginEnabled && (
          <div className={classes.badges}>
            {athlete.primaryAccount && (
              <Badge color='kiloBlue' variant='filled' radius='md'>
                Sub-account
              </Badge>
            )}
            {!athlete.loginEnabled && (
              <Badge color='red' variant='filled'>
                Login Disabled
              </Badge>
            )}
          </div>
        ))}
      <GeneralContent athlete={athlete} permission={permission} />
      <AthleteNotesContent athlete={athlete} permission={permission} />
      <PaymentMethodsContent athlete={athlete} permission={permission} />
      {!!athlete.connectedType && <ConnectedProfilesCard athlete={athlete} permission={permission} />}
      <ActivePackagesContent athlete={athlete} />
      <StatusHistoryCard athlete={athlete} permission={permission} />
    </div>
  );
};

export default GeneralInfo;
